/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SET_BUILT_IN_POLICIES } from './types';
import { IBuiltInPolicyItem, IPage, pageData } from '../../models/Policies/BuiltInPolicies';

export const initialState: {
  builtinPolicies: IBuiltInPolicyItem[];
  page: IPage;
} = {
  builtinPolicies: [],
  page: pageData
};

export const builtinPoliciesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_BUILT_IN_POLICIES:
      const {
        entities,
        meta: { page }
      } = action.builtinPolicies;

      return {
        ...state,
        builtinPolicies: [...entities],
        page: page
      };

    default:
      return state;
  }
};
